import { render, staticRenderFns } from "./PopOverSetting.vue?vue&type=template&id=8766ec98"
import script from "./PopOverSetting.vue?vue&type=script&lang=js"
export * from "./PopOverSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8766ec98')) {
      api.createRecord('8766ec98', component.options)
    } else {
      api.reload('8766ec98', component.options)
    }
    module.hot.accept("./PopOverSetting.vue?vue&type=template&id=8766ec98", function () {
      api.rerender('8766ec98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/institution/PopOverSetting.vue"
export default component.exports